import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [subscribeStatus, setSubscribeStatus] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        setSubscribeStatus('Thanks for subscribing!');
        setEmail('');
        // Add your subscription logic here
    };

    const services = [
        { name: 'Flight Booking', link: '/services/flight-booking' },
        { name: 'Car Rental', link: '/services/car-rental' },
        { name: 'Hajj & Umrah', link: '/services/hajj-umrah' },
        { name: 'Cruise Packages', link: '/services/cruise-packages' },
        { name: 'Tour Packages', link: '/services/tour-packages' },
        { name: 'Travel Insurance', link: '/services/travel-insurance' },
        { name: 'Passport & Visa', link: '/services/passport-visa' },
        { name: 'Forex Services', link: '/services/forex-services' }
    ];

    const footerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5 }
        }
    };

    return (
        <motion.footer
            className="footer"
            initial="hidden"
            animate="visible"
            variants={footerVariants}
        >
            <div className="footer-content">
                <motion.div className="footer-section" variants={itemVariants}>
                    <h3>About Us</h3>
                    <p>Excellent Travels - Your gateway to extraordinary adventures and unforgettable experiences around the world.</p>
                </motion.div>

                <motion.div className="footer-section" variants={itemVariants}>
                    <h3>Our Services</h3>
                    <ul className="services-list">
                        {services.map((service, index) => (
                            <motion.li
                                key={index}
                                whileHover={{ x: 10 }}
                                transition={{ duration: 0.2 }}
                            >
                                <Link
                                    to={service.link}
                                    className="footer-service-link"
                                >
                                    {service.name}
                                </Link>
                            </motion.li>
                        ))}
                    </ul>
                </motion.div>

                <motion.div className="footer-section" variants={itemVariants}>
                    <h3>Contact Us</h3>
                    <div className="contact-info">
                        <p>📍 UG-29, Central Market, Opp. Bapu Ki Kutia</p>
                        <p>Roshanpura, Bhopal-462003. (M.P.) India</p>
                        <p>📞 0755-4220722</p>
                        <p>📱 +91 9893020271, +91 9399418415</p>
                        <p>✉️ info@excellenttravels.co.in / sajidali3273@gmail.com</p>
                    </div>
                </motion.div>

                <motion.div className="footer-section" variants={itemVariants}>
                    <h3>Subscribe to Our Newsletter</h3>
                    <form onSubmit={handleSubscribe} className="subscribe-form">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            type="submit"
                        >
                            Subscribe
                        </motion.button>
                    </form>
                    {subscribeStatus && (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="subscribe-status"
                        >
                            {subscribeStatus}
                        </motion.p>
                    )}
                </motion.div>
            </div>

            <motion.div
                className="footer-bottom"
                variants={itemVariants}
            >
                <p>© 2024 Excellent Travels. All Rights Reserved.</p>
            </motion.div>
        </motion.footer>
    );
};

export default Footer;